"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncConnectionMode = void 0;
var AsyncConnectionMode;
(function (AsyncConnectionMode) {
    AsyncConnectionMode["POLLING"] = "POLLING";
    AsyncConnectionMode["WEBSOCKET"] = "WEBSOCKET";
})(AsyncConnectionMode || (exports.AsyncConnectionMode = AsyncConnectionMode = {}));
//# sourceMappingURL=types.js.map